import styled from 'styled-components';
import { FaArrowUpRightFromSquare } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { YoutubeMusicCircle } from '@quizzach/assets';

// »Radio redak«: no container — the YT Music disc, the playlist name and a
// quiet »quizzach radio« microline sit directly in the surrounding row, so
// the widget follows the theme instead of forcing a black pill.
const RadioLink = styled(Link)`
	display: inline-flex;
	align-items: center;
	gap: 12px;
	width: fit-content;
	text-decoration: none;
	color: ${({ theme }) => theme.palette.quiz.textSoft};

	.yt-lines {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		text-align: left;
	}

	.yt-title {
		font-family: ${({ theme }) => theme.typography.fontPrimary};
		font-size: 16px;
		letter-spacing: 0.5px;
		text-transform: uppercase;
		line-height: 1.15;
		color: ${({ theme }) => theme.palette.quiz.textMain};
		transition: color 0.15s;
	}

	.yt-sub {
		font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;
		font-size: 9.5px;
		font-weight: 700;
		letter-spacing: 1.8px;
		text-transform: uppercase;
		color: ${({ theme }) => theme.palette.quiz.textMuted};
		margin-top: 3px;
	}

	&:hover .yt-title {
		color: ${({ theme }) => theme.palette.quiz.textBrand};
	}
`;

export const YoutubeWidget = ({
	quizTitle,
	quizPlaylistUrl,
}: {
	quizTitle: string;
	quizPlaylistUrl: string;
}) => {
	const { t } = useTranslation();

	return (
		<RadioLink to={quizPlaylistUrl} target='_blank'>
			<YoutubeMusicCircle size={34} />
			<span className='yt-lines'>
				<span className='yt-title'>
					{t('quiz.youtube.playlist', { title: quizTitle })}
				</span>
				<span className='yt-sub'>quizzach radio</span>
			</span>
			<FaArrowUpRightFromSquare size={12} />
		</RadioLink>
	);
};
